import React from "react";

const SvgSpinner = props => <svg className="spinner" viewBox="0 0 66 66" {...props}><defs /><circle cx={33} cy={33} r={30} fill="none" className="path" /></svg>;

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJzcGlubmVyIiB2aWV3Qm94PSIwIDAgNjYgNjYiPgogIDxkZWZzLz4KICA8Y2lyY2xlIGN4PSIzMyIgY3k9IjMzIiByPSIzMCIgZmlsbD0ibm9uZSIgY2xhc3M9InBhdGgiLz4KPC9zdmc+Cg==";
export { SvgSpinner as ReactComponent };